<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="搜 索" goBack="true"></head-top>
		<div class='container'>
			<!-- 搜索框 -->
			<div class='search-bar'>
				<div class='search-box'>
					<input type="text" placeholder="输入关键字搜索" class='sear-input' v-model="name" @keyup.enter="showSearchResult()">
					<img :src='resourceDomain+"static/icon/search.png"' class='search-img'>
				</div>
				<span class='search-hint' @click='goBackIndex'>取消</span>
			</div>

			<div class='search-display'>
				<!-- 热门搜索 -->
				<div class='hot-search'>
					<div class='title-text flex_a' style="justify-content:flex-start;">
						<img :src='resourceDomain+"static/icon/hot.png"' class="searchicon">
						<div>热门搜索</div>
					</div>
					<div class='hot-search-tags'>
						<span class='tags' v-for="item in hotKeywords" :key="item.id" @click='onHistSearch(item.keyword)'>{{item.keyword}}</span>
					</div>
				</div>

				<!-- 搜索历史 -->
				<div class='history-search'>
					<div class='title-text history-line  flex_a' style="justify-content:flex-start;">
						<img :src='resourceDomain+"static/icon/history.png"' class="searchicon">
						<div>搜索历史</div>
						<div class='clear-history' v-if="bookSearch.length!=0">
							<img :src='resourceDomain+"static/icon/clear-his.png"' @click='clearSearch'>
						</div>
					</div>
					<div class='his-search-tags' v-for="(item, index) in bookSearch" :key="index">
						<span class='tags' @click='onHistSearch(item)'>{{item}}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 搜索结果 -->
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
			<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false" :finished-text="finishedText"
			 @load="loadMore" v-if="booksList.length > 0">
					<div  class="flex_a bookslist">
						<div v-for="(item, index) in booksList" :key="index" @click="toDetailPage(item.id)" class="bookitem">
							<!-- 满减优惠角标 -->
							<img :src='resourceDomain+"static/icon/discount.png"' class="discountIcon" v-if="item.discountStatus">
							<!-- 特价优惠角标 -->
							<img :src='resourceDomain+"static/icon/special.png"' class="discountIcon" v-if="item.specialOfferStatus">
							<img :src="resourceDomain+item.pic" v-if="item.pic" class="bookpic" />
							<div class="bookdetail">
								<div class="bookname color_a font_size_a ">
									<div class="ellipsis_2">
										{{item.title}}
									</div>
								</div>
								<div class="flex_c number">
									<div class="money color_d">￥<span class="font_size_c">{{item.specialOfferStatus?item.specialOfferPrice:item.price}}</span></div>
									<div class="color_f font_size_d">
										销量:{{item.sellCount}}件
									</div>
								</div>
								<!-- 购物车和立即购买 -->
								<div class="btns flex_c color_f font_size_b">
									<div class="color_g" @click.stop="addToCart(item.id)">加入购物车</div>
									<div class="color_d" @click.stop="tobuy(item.id)">立即购买</div>
								</div>
							</div>
						</div>
					</div>
			</van-list>
			<div v-else class="noorder">
				<div class="color_e font_size_c paddingb" style="text-align:center;">
					<img :src='resourceDomain+"static/icon/no_order.png"' class="noorderimg">
					暂无数据，逛逛别的分类吧~
				</div>
			</div>
		</van-pull-refresh>


		<!-- 购物车 -->
		<div class="cartcell" @click="tocart">
			<img :src='resourceDomain+"static/icon/cart.png"' class="carticon">
			<van-badge :content="cartnumber" max="99" class="cartnumber" />
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import tool from "@/common/tool";
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	export default {
		name: 'BookSearch',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				hotKeywords: [],
				name: '',
				pages: undefined,
				bookSearch: [], //历史关键词
				booksList: [],
				page: 0,
				finishedText: "",
				loading: false, //上拉加载用
				finished: false, //上拉加载用
				isLoading: false, //下拉刷新用
				cartnumber: 0, //购物车数量
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {
			this.searchKeywords()
			this.getRecentSearch()
			this.updatePage()
		},
		activated() {

		},
		computed: {
			...mapGetters('userModule', ['getToken'])
		},
		methods: {
			
// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				if (this.getToken()) {
					this.getBookShoppingNumber()
				} else {
					this.cartnumber = 0
				}
			},
			// 立即购买
			tobuy(bookId) {
				// 判断是否登录
				if (this.getToken()) {
					// 登录了，跳转提交订单
					console.log(" 登录了，跳转提交订单")
					sessionStorage.setItem('CURRENT_WAITING_PAY_BOOK_ID', bookId)
					// 如果是在微信网页内支付，就需要先获取code，再用code获取openid
					if (tool.isWxEnv()) {
						let url = encodeURIComponent(api.aPI_BASE_URL+"/#/book_confirm_order")
						window.location.href = tool.getCOdeBySnsapiBase(url);
					} else {
						this.$router.push({
							path: '/book_confirm_order'
						})
					}
				} else {
					// 没登录，去登录
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},

			// 点击加入购物车
			addToCart(bookId) {
				var _this = this
				if (this.getToken()) {
					api.get('/book/addBookToShoppingCart', {
						bookId: bookId
					}).then(res => {
						if (res.success) {
							this.$toast.success("添加成功！")
							this.cartnumber = Number(this.cartnumber) + 1
						} else {
							this.$toast(res.message);
							setTimeout(function() {
								_this.booksList = []
								_this.page = 0
								_this.searchBooks()
							}, 1000);
						}
					})
				} else {
					// 没登录，去登录
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},


			//年月日
			dateFormat(time) {
				// var date = new Date(time)
				// return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
				var format = time.replace(/-/g, '/')
				var date = new Date(format)
				return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
			},

			// 点击购物车图标
			tocart() {
				if (this.getToken()) {
					this.$router.push({
						path: '/book_cart'
					})
				} else {
					// 没登录，去登录
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},
			// 获取热门搜索关键词
			searchKeywords() {
				api.get('/p/book/search/searchKeywords', {}).then(res => {
					if (res.success) {
						console.log(res.data, "-----searchKeywords------")
						this.hotKeywords = res.data
					} else {
						this.$toast(res.message)
					}
				})
			},

			// 获取购物车数量
			getBookShoppingNumber() {
				api.get('/book/getBookShoppingNumber', {}).then(res => {
					if (res.success) {
						console.log(res.data, "getBookShoppingNumber")
						this.cartnumber = res.data
					} else {
						this.$toast(res.message)
					}
				})
			},
			/**
			 * 获取历史搜索
			 */
			getRecentSearch: function() {
				let bookSearch = localStorage.getItem('cmsBookSearch')
				if (bookSearch) {
					this.bookSearch = JSON.parse(bookSearch)
				}
			},

			/* 搜索提交 */
			showSearchResult: function() {
				// 记录最近搜索
				let bookSearch = localStorage.getItem('cmsBookSearch');
				if (bookSearch) {
					bookSearch = JSON.parse(bookSearch)
				} else {
					bookSearch = []
				}
				bookSearch = bookSearch.filter(item => item !== this.name)
				//this.name 不为空时
				if (this.name) {
					bookSearch.unshift(this.name);
				}
				if (bookSearch.length > 10) {
					bookSearch.pop();
				}
				localStorage.setItem('cmsBookSearch', JSON.stringify(bookSearch));
				this.getRecentSearch()

				// 检索刷新列表
				this.page = 0
				this.booksList = []
				this.loading = true
				this.finished = false
				this.searchBooks()

			},

			/*搜索结果列表*/
			searchBooks() {
				console.log("this.name=>>>" + this.name)
				let booksList = this.booksList
				let page = this.page + 1
				api.get('/p/book/search/searchBooksByBookName', {
					name: this.name,
					page: page,
					size: 6
				}).then(res => {
					console.log(res, "-----searchBooks------")
					if (res.success) {
						if (res.data.total > 0) {
							for (var i = 0; i < res.data.books.length; i++) {
								booksList.push(res.data.books[i])
							}
							this.page = page
							this.pages = res.data.pages
							this.booksList = booksList

							// 加载状态结束
							this.isLoading = false
							this.loading = false
							// 设置是否可以继续上拉加载
							if (this.page == this.pages) {
								this.finished = true
							} else {
								this.finished = false
							}
							this.finishedText = "没有更多了~"
						} else {
							this.finished = true
							this.booksList = []
							this.finishedText = ""
						}
					} else {
						this.$toast(res.message)
					}
				})
			},

			/* 清空搜索历史 */
			clearSearch: function() {
				localStorage.removeItem('cmsBookSearch');
				this.bookSearch = []
			},

			//点击热门搜素关键词
			onHistSearch: function(v) {
				this.name = v
				this.booksList = []
				this.page = 0
				this.loading = true
				this.finished = false
				this.searchBooks()
			},

			// 点击图书 跳转图书详情页
			toDetailPage(bookId) {
				this.$router.push({
					'path': '/book_detail',
					query: {
						bookId: bookId
					}
				})
			},

			goBackIndex: function() {
				this.$router.go(-1)
			},

			/**下拉刷新 */
			onRefresh() {
				this.booksList = []
				this.page = 0
				this.searchBooks()
				this.isLoading = false;

			},

			/**上拉加载 */
			loadMore() {
				console.log("触发loadMore....")
				if (this.page === this.pages) {
					this.$toast('没有更多咯~')
				} else {
					this.searchBooks()
				}
			},

		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.margin_top_b{
		margin-top:10px;
	}
	// 许可证图标
	.xkzIcon {
		display: block;
		width: 12px;
		height: 12px;
		margin-right: 4px;
	}
	
	// 满减优惠活动角标
	.discountIcon {
		position: absolute;
		left: 0;
		top: 0;
		width: 40px;
		height: 22px;
		display: block;
		border-top-left-radius: 5px;
	}

	.noorderimg {
		width: 345px;
		height: 172.5px;
		margin: 25px auto;
	}

	.paddingb {
		padding: 15px 0;
	}

	.noorder {
		width: 345px;
		margin-top: 10px;
		padding: 0 15px 15px;
	}


	.searchicon {
		width: 20px;
		height: 20px;
		margin-right: 7.5px;
	}

	.container {
		padding-top: 48px;
	}

	.search-bar {
		width: 100%;
		position: fixed;
		top: 48px;
		left: 0;
		color: #777;
		background: #fff;
		box-shadow: 0 1px 3px #eee;
		z-index: 3;
	}

	.search-bar .search-box {
		position: relative;
		height: 30px;
		background: #f7f7f7;
		z-index: 999;
		width: 80%;
		margin-left: 35px;
		border-radius: 25px;
		margin: 10px 0 10px 10px;
	}

	.sear-input {
		height: 30px;
		width: 250px;
		// border-radius: 25px;
		border: unset;
		margin: 0 15px 0 32px;
		line-height: 30px;
		vertical-align: top;
		background: unset;
		padding: 0;
		font-size: 14px;
	}

	.search-bar .search-hint {
		font-size: 14px;
		position: absolute;
		right: 15px;
		top: 15.5px;
		color: #e43130;
	}

	.search-bar .search-box .search-img {
		width: 16px;
		height: 16px;
		position: absolute;
		left: 10px;
		top: 7px;
		display: block;
	}

	/* 热门搜索&搜索历史 */

	.search-display {
		background: #fff;
		padding: 10px 15px 0;
		margin-top: 50px;
		width: 345px;
	}

	.search-display .title-text {
		padding-bottom: 15px;
		font-size: 16px;
		color: #000;
		font-weight: 500;
	}

	.hot-search .hot-search-tags {
		overflow: hidden;
		font-size: 13px;
		text-align: center;
	}

	.hot-search .hot-search-tags .tags {
		display: block;
		max-width: 100%;
		overflow: hidden;
		float: left;
		border-radius: 25px;
		white-space: nowrap;
		text-overflow: ellipsis;
		background-color: #f2f2f2;
		box-sizing: border-box;
		margin-right: 10px;
		margin-bottom: 15px;
		padding: 5px 15px;
	}

	/* 搜索历史 */

	.history-search .title-text.history-line {
		position: relative;
		border-top: 1px solid #eee;
		padding-top: 15px;
	}

	.history-search .his-search-tags {
		overflow: hidden;
		font-size: 13px;
		text-align: center;
		display: inline-block;
	}

	.history-search .his-search-tags .tags {
		max-width: 150px;
		overflow: hidden;
		float: left;
		border-radius: 25px;
		white-space: nowrap;
		text-overflow: ellipsis;
		background-color: #f2f2f2;
		box-sizing: border-box;
		margin-right: 10px;
		margin-bottom: 15px;
		padding: 5px 15px;
	}

	.clear-history img {
		width: 16px;
		height: 16px;
		position: absolute;
		right: 5px;
		top: 15px;
	}

	.newestList_title {
		color: #000;
		font-size: 16px;
		letter-spacing: 1px;
		width: 100%;
		line-height: 22px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		font-weight: 500;
	}

	/*课程列表*/
	.bookslist {
		flex-wrap: wrap;
		width: 345px;
		margin: 0 auto;
		padding: 15px 0 0;
	}

	.bookitem {
		width: 163px;
		margin-right: 14px;
		margin-bottom: 15px;
		border-radius: 5px;
		border: 1px solid #ccc;
		position: relative;
	}

	.bookitem:nth-child(2n) {
		margin-right: 0;
	}

	.bookpic {
		width: 163px;
		height: 163px;
		border-radius: 5px 5px 0 0;
		display: block;
	}

	.bookdetail {
		background-color: #f9f9f9;
		border-radius: 0 0 5px 5px;
	}

	.bookname {
		height: 40px;
		line-height: 20px;
		padding: 10px 8px 8px;
		width: 147px;
	}

	.number {
		padding: 0 8px 8px;
		width: 147px;
	}

	.money {
		font-size: 10px;
	}

	.btns {
		border-top: 1px solid #ccc;
		padding: 10px 8px;
		width: 147px;
	}

	// 购物车悬浮
	.cartcell {
		position: fixed;
		right: 15px;
		bottom: 10vh;
		width: 40px;
		height: 40px;
		border-radius: 20px;
		background-color: #Fff;
	}

	.carticon {
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.cartnumber {
		position: absolute;
		min-width: 20px;
		top: 0;
		left: -45%;
		transform: translateX(50%);
	}
</style>
